// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"229":"1d761bde","405":"67f6b899","453":"2865efc1"}[chunkId] + ".chunk.js";
};